import React from 'react';
import { components } from 'react-select';
import { Close } from 'components/SvgIcons';
import { CFM_STONE } from 'constants/Colors';

export default (props) =>
    components.ClearIndicator && (
        <components.ClearIndicator {...props}>
            <Close color={CFM_STONE} />
        </components.ClearIndicator>
    );
